<template>
  <kst-table action input-mode
    :data="userItems"
    :failureList="failureList" 
    :loading="isListLoading"  
  >
    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip v-if="row.Errors.length > 0" error-mode>
          <template #content>
            <kst-list :items="row.Errors"/>
          </template>
          <kst-icon error-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      field="Name"
      :label="ItemCatalog.Name.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="ItemCatalog"
        :index="index" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip info-mode>
          <template #content>
            <kst-list info-mode :items="Model.getItemInfo(row)"/>
          </template>
          <kst-icon info-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="ks-col-packaging"
      field="PackagingName"
      :label="ItemCatalog.PackagingName.Label"
    >
      <template v-if="row.PurchasingItemID">
        <kst-output box-off field-only
          field="Packaging" :data="row" :catalog="ItemCatalog"
        />
      </template>
      <template v-else>
        <kst-input error-off field-only
          :field="column.field" :data="row" :catalog="ItemCatalog"
          :index="index" :options="row.PackagingOptions"
          @input="handlePackaging(row)" @error="handleRowErrors"
        />
      </template>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="ks-col-qty"
      field="Quantity"
      :label="ItemCatalog.Quantity.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="ItemCatalog"
        :index="index" @input="handleQuantity(row)" @error="handleRowErrors"
      />
    </b-table-column>

    <b-table-column
      v-slot="{ column, row, index }"
      cell-class="ks-col-price-button"
      field="BuyPrice"
      :label="ItemCatalog.BuyPrice.Label"
    >
      <kst-input error-off field-only
        :field="column.field" :data="row" :catalog="ItemCatalog"
        :index="index" @input="handleBuyPrice(row)" @error="handleRowErrors"
      >
        <template #right>
          <div class="control">
            <kst-tooltip search-mode hover-only
              position="is-bottom"
              :content="ItemCatalog.BuyPrice.Label"
            >
              <kst-button search-mode @click="handleSearch_Price(index)"/>
            </kst-tooltip>
          </div>
        </template>
      </kst-input>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-subtotal"
      field="ExpenseAmount"
      :label="ItemCatalog.ExpenseAmount.Label"
    >
      <kst-output box-off field-only
        :field="column.field" :data="row" :catalog="ItemCatalog"
      />
    </b-table-column>

    <template #action="{ index }">
      <kst-tooltip delete-mode hover-only :content="Model.ReceiveItem.Module.FullName">
        <kst-button delete-mode is-round @click="handleRowDelete(index)"/>
      </kst-tooltip>
    </template>

    <template #empty-body>
      <ValidationProvider v-slot="{ errors }" name="userItems" rules="required">
        <kst-error :array-blank-mode="!!errors"/>
      </ValidationProvider>
    </template>
  </kst-table>
</template>

<script>
import DialogMixin from "@/mixins/DialogMixin.js";
import Catalog from "../ReceiveCatalog.js";
import Info from "../ReceiveInfo.js";
import ItemCatalog from "../ReceiveItemCatalog.js";
import Model from "../ReceiveModel.js";

export default {
  mixins: [DialogMixin],
  props: {
    userData: Object,
    userItems: Array,
    isListLoading: Boolean,
    failureList: String
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model,
    ItemCatalog: ItemCatalog,
    selectedIndex: null
  }),
  methods: {
    handlePackaging(item) {
      Model.updateItem(item);
      Model.updateDetails(this.userData, this.userItems);
    },
    handleQuantity(item) {
      Model.updateItem(item);
      Model.updateDetails(this.userData, this.userItems);
    },
    handleBuyPrice(item) {
      Model.updateItem(item);
      Model.updateDetails(this.userData, this.userItems);
    },

    handleRowDelete(index) {
      this.selectedIndex = index;
      this.showConfirm(
        Info.Message.Edit_ConfirmDeleteItem,
        this.handleRowDelete_Confirm,
        this.handleRowDelete_Cancel
      );
    },
    handleRowDelete_Confirm() {
      const item = this.userItems[this.selectedIndex];
      this.$emit(this.$kst.Enum.Event.Submit, item);

      this.userItems.splice(this.selectedIndex, 1);
      Model.updateDetails(this.userData, this.userItems);

      this.selectedIndex = null;
    },
    handleRowDelete_Cancel() {
      this.selectedIndex = null;
    },
    handleRowErrors(errors, field, index) {
      Model.setItemErrors(this.userItems[index], field, errors);
    },
    handleSearch_Price(index) {
      this.$emit(this.$kst.Enum.Event.Callback, {
        isPrice: true,
        index: index
      });
    }
  }
}
</script>